import React from "react";
import { Link } from "react-router-dom";

/** kind: hash → anchor on same or other page; route → React Router */
export function SiteNavLink({ link, className, onClick, testid }) {
  if (!link || link.visible === false) return null;
  const path = link.path || "/";
  if (link.kind === "route") {
    return (
      <Link to={path} data-testid={testid} className={className} onClick={onClick}>
        {link.label}
      </Link>
    );
  }
  return (
    <a href={path} data-testid={testid} className={className} onClick={onClick}>
      {link.label}
    </a>
  );
}
